import React from 'react';
import AppShell from './layout/AppShell';

const App: React.FC = () => {
  return <AppShell />;
};

export default App;
